// extracted by mini-css-extract-plugin
export default {"main":"App_main_TQMSS","navigation":"App_navigation_THJvx","center":"App_center_DJkyn"};